/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  DeleteApiV1SerievideoVideoidLangsIdMutationResponse,
  DeleteApiV1SerievideoVideoidLangsIdPathParams,
  DeleteApiV1SerievideoVideoidLangsIdQueryParams,
  DeleteApiV1SerievideoVideoidLangsId401,
  DeleteApiV1SerievideoVideoidLangsId404,
  DeleteApiV1SerievideoVideoidLangsId500,
} from "../../types/serieVideoIdiomasController/DeleteApiV1SerievideoVideoidLangsId.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { deleteApiV1SerievideoVideoidLangsId } from "../../clients/serieVideoIdiomasController/deleteApiV1SerievideoVideoidLangsId.ts";

export const deleteApiV1SerievideoVideoidLangsIdMutationKey = () =>
  [{ url: "/api/v1/serievideo/:videoId/langs/:id" }] as const;

export type DeleteApiV1SerievideoVideoidLangsIdMutationKey = ReturnType<
  typeof deleteApiV1SerievideoVideoidLangsIdMutationKey
>;

export function deleteApiV1SerievideoVideoidLangsIdMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey = deleteApiV1SerievideoVideoidLangsIdMutationKey();
  return mutationOptions<
    DeleteApiV1SerievideoVideoidLangsIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1SerievideoVideoidLangsId401
      | DeleteApiV1SerievideoVideoidLangsId404
      | DeleteApiV1SerievideoVideoidLangsId500
    >,
    {
      videoId: DeleteApiV1SerievideoVideoidLangsIdPathParams["videoId"];
      id: DeleteApiV1SerievideoVideoidLangsIdPathParams["id"];
      params?: DeleteApiV1SerievideoVideoidLangsIdQueryParams;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ videoId, id, params }) => {
      return deleteApiV1SerievideoVideoidLangsId(videoId, id, params, config);
    },
  });
}

/**
 * @description Remove uma tradução (idioma) do vídeo. **(Requer Authorization para autenticação)**
 * @summary Excluir idioma do vídeo (Requer Authorization para autenticação)
 * {@link /api/v1/serievideo/:videoId/langs/:id}
 */
export function useDeleteApiV1SerievideoVideoidLangsId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiV1SerievideoVideoidLangsIdMutationResponse,
      ResponseErrorConfig<
        | DeleteApiV1SerievideoVideoidLangsId401
        | DeleteApiV1SerievideoVideoidLangsId404
        | DeleteApiV1SerievideoVideoidLangsId500
      >,
      {
        videoId: DeleteApiV1SerievideoVideoidLangsIdPathParams["videoId"];
        id: DeleteApiV1SerievideoVideoidLangsIdPathParams["id"];
        params?: DeleteApiV1SerievideoVideoidLangsIdQueryParams;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiV1SerievideoVideoidLangsIdMutationKey();

  const baseOptions = deleteApiV1SerievideoVideoidLangsIdMutationOptions(
    config,
  ) as UseMutationOptions<
    DeleteApiV1SerievideoVideoidLangsIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1SerievideoVideoidLangsId401
      | DeleteApiV1SerievideoVideoidLangsId404
      | DeleteApiV1SerievideoVideoidLangsId500
    >,
    {
      videoId: DeleteApiV1SerievideoVideoidLangsIdPathParams["videoId"];
      id: DeleteApiV1SerievideoVideoidLangsIdPathParams["id"];
      params?: DeleteApiV1SerievideoVideoidLangsIdQueryParams;
    },
    TContext
  >;

  return useMutation<
    DeleteApiV1SerievideoVideoidLangsIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1SerievideoVideoidLangsId401
      | DeleteApiV1SerievideoVideoidLangsId404
      | DeleteApiV1SerievideoVideoidLangsId500
    >,
    {
      videoId: DeleteApiV1SerievideoVideoidLangsIdPathParams["videoId"];
      id: DeleteApiV1SerievideoVideoidLangsIdPathParams["id"];
      params?: DeleteApiV1SerievideoVideoidLangsIdQueryParams;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiV1SerievideoVideoidLangsIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1SerievideoVideoidLangsId401
      | DeleteApiV1SerievideoVideoidLangsId404
      | DeleteApiV1SerievideoVideoidLangsId500
    >,
    {
      videoId: DeleteApiV1SerievideoVideoidLangsIdPathParams["videoId"];
      id: DeleteApiV1SerievideoVideoidLangsIdPathParams["id"];
      params?: DeleteApiV1SerievideoVideoidLangsIdQueryParams;
    },
    TContext
  >;
}
